<template>
  <div class='footer'>
    <div class='inner'>
      <span class='copyright'>
        Made with ❤️ in <a href="https://en.wikipedia.org/wiki/Lahore" target="_blank">LHR</a>
        +
        <a href="https://en.wikipedia.org/wiki/Franklin,_New_Hampshire" target="_blank">NH</a>.

        &copy; 2019-2020 <a href="http://criminull.com" target="_blank">Criminull, Inc.</a>
      </span>
      <br />
      <span class="copyright">
        <router-link to="/privacy" exact-active-class="nav-active-link">Privacy</router-link> |
        <router-link to="/tos" exact-active-class="nav-active-link">Terms</router-link> |
        <a href='mailto:hi@naminus.com'>Contact</a>
      </span>

    </div>
  </div>
</template>

<script>
  export default {
    name: 'Footer'
  }
  import '@/resources/scripts/nav.js'
</script>